"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _colors = require("@material-ui/core/colors");
var _styles = require("@material-ui/core/styles");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Translations = require("../Translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = (0, _styles.createMuiTheme)({
  palette: {
    primary: _colors.red
  }
});
var FileUploader = /*#__PURE__*/function (_React$Component) {
  _inherits(FileUploader, _React$Component);
  var _super = _createSuper(FileUploader);
  function FileUploader() {
    var _this;
    _classCallCheck(this, FileUploader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var hasError = false;
      var file = event.target.files[0];
      // Check if the field has a maxtotalSize validation
      if (_this.props.maxTotalSize) {
        // Check if the selected filed meets the validation
        if (file.size >= _this.props.maxTotalSize) {
          _this.props.setFieldError(_this.props.name, "".concat(_this.props.intl.formatMessage({
            id: "La taille des images doit être inférieure à",
            defaultMessage: "La taille des images doit être inférieure à"
          }), " ").concat(_this.props.maxTotalSize / 1000000, " MB"));
          _this.props.setFieldTouched(_this.props.name, true, false);
          hasError = true;
        }
      }
      // If there are no errors proceed with setting the file
      if (!hasError) {
        // Before setting the file check if it's a supported format
        if (_this.props.acceptedFiles.indexOf(file.type) !== -1) {
          _this.props.setFieldValue(_this.props.name, file);
        } else {
          _this.props.setFieldError(_this.props.name, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
            id: "Format de fichier non pris en charge.",
            defaultMessage: "Format de fichier non pris en charge."
          }));
          _this.props.setFieldTouched(_this.props.name, true, false);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleDelete", function () {
      _this.props.setFieldValue(_this.props.name, '');
    });
    return _this;
  }
  _createClass(FileUploader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        accept = _this$props.accept;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styles.MuiThemeProvider, {
        theme: this.props.errors[this.props.name] && this.props.touched[this.props.name] ? styles : this.props.theme
      }, /*#__PURE__*/_react.default.createElement(_core.Button, {
        variant: "outlined",
        color: this.props.errors[this.props.name] && this.props.touched[this.props.name] ? 'primary' : 'default',
        style: {
          marginTop: 16
        }
      }, !this.props.values[this.props.name] ? label : this.props.values[this.props.name].name, /*#__PURE__*/_react.default.createElement("input", {
        type: "file",
        accept: accept,
        onChange: this.handleChange,
        style: {
          cursor: 'pointer',
          display: 'block',
          height: '100%',
          opacity: 0,
          position: 'absolute',
          width: '100%'
        }
      }), !this.props.values[this.props.name] ? /*#__PURE__*/_react.default.createElement(_core.Icon, {
        style: {
          marginLeft: 25
        }
      }, "cloud_upload") : /*#__PURE__*/_react.default.createElement(_core.IconButton, {
        onClick: this.handleDelete
      }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "clear")))));
    }
  }]);
  return FileUploader;
}(_react.default.Component);
var _default = (0, _reactIntl.injectIntl)(FileUploader);
exports.default = _default;